const house_sec2Object = (payload) => {
  return {
    type: "housesec2",
    payload,
  };
};

export default house_sec2Object;
